import { z } from 'zod';

export const logInSchema = z.object({
  email: z.string().email(),
  password: z.string(),
  stay_logged_in: z.boolean(),
});

export type logInSchemaType = z.infer<typeof logInSchema>;
